(() => {
  let loader;
  const loadVerification = () => {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (!loader) loader = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.onload = () => window.turnstile ? resolve(window.turnstile) : reject(new Error('verification'));
      script.onerror = () => { script.remove(); loader = null; reject(new Error('verification')); };
      document.head.append(script);
    });
    return loader;
  };
  function attach(form) {
    if (form.dataset.connected) return;
    form.dataset.connected = 'true';
    const quiz = form.closest('xq-routine-quiz');
    const status = form.querySelector('[data-signup-status]');
    const submit = form.querySelector('[type="submit"]');
    const text = JSON.parse(form.querySelector('[data-signup-language]').textContent);
    let widget, token = '', busy = false, attempt, lastInput, submitted = false;
    const message = (key) => { status.textContent = text[key]; };
    const initialise = async () => {
      if (widget !== undefined || !quiz.dataset.resultKey) return;
      try {
        const verification = await loadVerification();
        if (!form.isConnected || widget !== undefined) return;
        widget = verification.render(form.querySelector('[data-verification]'), {
          sitekey: form.dataset.sitekey,
          action: 'xquisit_quiz',
          theme: 'light',
          size: 'flexible',
          callback: (value) => { token = value; },
          'expired-callback': () => { token = ''; },
          'error-callback': () => { token = ''; message('verification_error'); }
        });
      } catch { message('verification_error'); }
    };
    quiz.addEventListener('xq:result', () => {
      if (!busy) {
        submitted = false;
        submit.disabled = false;
        status.textContent = '';
        attempt = undefined;
        lastInput = undefined;
      }
      initialise();
    });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (busy || submitted || !form.reportValidity()) return;
      if (!token) { message('verification_pending'); initialise(); return; }
      const email = form.querySelector('[type="email"]').value.trim().toLowerCase();
      const consent = form.querySelector('[type="checkbox"]').checked;
      const result = quiz.dataset.resultKey;
      const fingerprint = JSON.stringify([email, consent, result]);
      if (fingerprint !== lastInput) { attempt = crypto.randomUUID(); lastInput = fingerprint; }
      busy = true;
      submit.disabled = true;
      const restart = quiz.querySelector('[data-restart]');
      restart.disabled = true;
      message('saving');
      try {
        const response = await fetch(form.dataset.endpoint, {
          method: 'POST',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, consent, result, submission_id: attempt,
            turnstile_token: token, website: form.querySelector('[name="website"]').value }),
          signal: AbortSignal.timeout(20000)
        });
        const data = await response.json();
        if (response.ok && data.saved === true) { submitted = true; message('success'); }
        else message(response.status === 409 ? 'review_required' : 'save_error');
      } catch { message('save_error'); }
      finally {
        busy = false;
        submit.disabled = submitted;
        restart.disabled = false;
        token = '';
        if (widget !== undefined && window.turnstile) window.turnstile.reset(widget);
      }
    });
    initialise();
  }
  const initialiseForms = () => document.querySelectorAll('[data-xq-cloudflare-signup]').forEach(attach);
  initialiseForms();
  document.addEventListener('shopify:section:load', initialiseForms);
})();
